// extracted by mini-css-extract-plugin
export var deliveryRow = "_ta-a";
export var fixedHeight = "_ta-4";
export var freightLogo = "_ta-9";
export var fullWidth = "_ta-3";
export var priceColumn = "_ta-5";
export var radioSelected = "_ta-7";
export var radioUnselected = "_ta-6";
export var selectedOption = "_ta-2";
export var selectedOptionContainer = "_ta-1";
export var selection = "_ta-0";
export var tallSkeletonText = "_ta-8";